import { createRouter, createWebHistory } from 'vue-router'

// 导入视图组件
import Home from '@/views/home/index.vue'
import About from '@/views/about/index.vue'
import News from '@/views/news/index.vue'
import Contact from '@/views/contact/index.vue'
import Recruitment from '@/views/recruitment/index.vue'
import CaseDetails from "@/views/userCase/caseDetails.vue"
import NewsDetails from "@/views/news/details.vue"
import NewsList from "@/views/news/list.vue"
import ErrorIndex from "@/views/main/404.vue"
export const routes = [
  {
    path: '/404',
    name: '404',
    isMenu: true,
    isShow:false,
    component: ErrorIndex,
    meta: {
      title: '404'
    }
  },
  {
    path: '/',
    name: 'home',
    isMenu: true,
    isShow:true,
    component: Home,
    meta: {
      title: '首页',
      keyword: 'HomePage'
    }
  },
  {
    path: '/about',
    name: 'about',
    isMenu: true,
    isShow:true,
    component: About,
    meta: {
      title: '关于我们',
      keyword: 'AboutUs'
    }
  },
  {
    path: '/news',
    name: 'news',
    isMenu: true,
    isShow:true,
    component: News,
    meta: {
      title: '新闻动态',
      keyword: 'News'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    isMenu: true,
    isShow:true,
    component: Contact,
    meta: {
      title: '联系我们',
      keyword: 'ContactUs'
    }
  },
  {
    path: '/recruitment',
    name: 'recruitment',
    isMenu: true,
    isShow:true,
    component: Recruitment,
    meta: {
      title: '招聘信息',
      keyword: 'Job'
    }
  },
  {
    path: '/products',
    name: 'products',
    isShow:true,
    meta: {
      title: '数字化解决方案',
      keyword: 'Digital'
    }
  },
  {
    path: '/caseDetails',
    name: 'caseDetails',
    isMenu: true,
    isShow:false,
    component: CaseDetails,
    meta: {
      title: '客户案例详情'
    }
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    isMenu: true,
    isShow:false,
    component: NewsDetails,
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/newsList',
    name: 'newsList',
    isMenu: true,
    isShow:false,
    component: NewsList,
    meta: {
      title: '新闻列表'
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  }
})

// 动态设置页面标题
router.beforeEach((to, from, next) => {
  document.title = '企业管理咨询公司-知名管理咨询机构-深圳汇思益企业管理咨询'
  if (!to.matched.length) { // 没有匹配到任何路由
    next('/404')
    return
  }
  next()
})

export default router
